module.exports = __webpack_public_path__ + "static/media/girl.69cddb8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/product-step/girl.png
// module id = 1645
// module chunks = 0